<template>
  <div class="labeler">
    <div class="snapshot-container"
         v-ratio="{ratio: 1920 / (1080-(config.xs||284)*2)}">
      <div class="snapshot-middle">
        <Snapshot v-ratio="{ratio: 1920 / 1080}"
                  :mx-data="mxData"
                  :row-range="config.xs"
                  :full-detect-result="fullDetectResult"
                  :element-loading-text="loadingText"
                  :draw-type="drawType"
                  :label-list="labelList"
                  :show-detect="showDetect"
                  :show-label="showLabel"
                  :show-draw="isShowDraw"
                  :show-blind="showBlind"
                  :label-types="labelTypes"
                  :can-draw="true"
                  :magnifier="showMagnifier"
                  :diameter="diameter"
                  :blind="blind"
                  @onClick="onClick"
                  @onMove="onMove"
                  @onDraw="onDraw"
                  v-loading="isLoading"
                  element-loading-background="white"></Snapshot>
      </div>
      <div class="labeler-play">
        <div>
          <el-button type="primary"
                     size="mini"
                     round
                     :disabled="isLoading"
                     @click="togglePlay">
            {{playId===null?'播放':'暂停'}}
          </el-button>
        </div>
        <div style="flex:1">
          <el-slider class="snapshot-slider"
                     show-input
                     input-size="mini"
                     :min="0"
                     :max="totalCount-1"
                     :disabled="isLoading"
                     v-model="frameIdx"></el-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snapshot from '@/components/Snapshot/index.vue'
import H264Decoder from '@/utils/h264Decoder'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { yamlToJson } from '@/utils/jsYaml'
import c from '@/config'

export default {
  props: {
    videoUrl: {
      type: String,
      require: true,
    },
    yamlUrl: {
      type: String,
      require: true,
    },
    value: {
      default: 1,
    },
    labelList: {
      default: () => [],
    },
    showDraw: {
      default: true,
    },
    blind: {
      default: () => ({}),
    },

    // Tools
    showMagnifier: {
      default: false,
    },
  },
  data() {
    return {
      totalCount: 1,
      canvasData: [],
      configs: [],

      // status
      videoLoaded: false,
      start: null,

      // play
      playId: null,

      // other
      labelTypes: c.labelTypes,
    }
  },
  computed: {
    ...mapFields([
      'frameIdx',
      'modified',
      'diameter',
      'downloadingVideo',
      'decodingVideo',
      'useCache',
    ]),
    ...mapState([
      'showDetect',
      'showLabel',
      'showBlind',
      'encodingVideo',
      'shieldInfo',
    ]),
    ...mapState({
      drawType: state => state.label.drawType,
      frameRange: state => state.label.frameRange,
    }),
    ...mapGetters(['getDecodedVideo', 'isLoading']),
    mxData() {
      return this.canvasData[this.frameIdx]
    },
    count() {
      return this.canvasData.length
    },
    config() {
      return (
        this.configs[this.frameIdx] || {
          xs: 0,
          data: {
            cols: 32,
            data: [],
          },
        }
      )
    },
    fullDetectResult() {
      const config = this.config
      return {
        blockHeight: config.blockHeight,
        blockWidth: config.blockWidth,
        cols: config.data.cols,
        detectResults: config.data.data,
        rows: config.data.rows,
        xs: config.xs,
        ys: config.ys,
      }
    },
    loadingText() {
      if (this.encodingVideo && this.videoLoaded) {
        return '正在解码视频文件'
      }
      return '正在加载视频文件'
    },
    isShowDraw() {
      return (
        this.showDraw &&
        (this.frameIdx >= this.frameRange[0] &&
          this.frameIdx <= this.frameRange[1])
      )
    },
  },
  mounted() {
    this.processVideo(this.videoUrl)
    this.processYaml(this.yamlUrl)
  },
  methods: {
    ...mapMutations('label', ['addLabel']),
    ...mapMutations(['addDecodedVideo']),
    processVideo(videoUrl) {
      if (!videoUrl) return
      const cachedVideo = this.getDecodedVideo(videoUrl)
      if (cachedVideo) {
        const canvasData = cachedVideo.decodedVideo
        this.$emit('decoded', canvasData, canvasData.length)
        this.canvasData = canvasData
        this.totalCount = canvasData.length
        this.useCache = true
      } else {
        this.useCache = false
        this.videoLoaded = false
        this.downloadingVideo = true
        this.decodingVideo = true

        H264Decoder(videoUrl, {
          onLoadedVideo: () => {
            this.videoLoaded = true
            this.start = +new Date()
            this.downloadingVideo = false
          },
          onFinishDecode: (canvasData, totalCount) => {
            console.log(+new Date() - this.start)
            this.$emit('decoded', canvasData, totalCount)
            this.canvasData = canvasData
            this.totalCount = totalCount
            this.addDecodedVideo({ videoUrl, decodedVideo: canvasData })
            this.decodingVideo = false
          },
        })
      }
    },
    processYaml(path) {
      if (!path) return
      fetch(path)
        .then(res => res.text())
        .then(data => {
          const configArr = yamlToJson(data)
          this.configs = configArr
        })
    },
    togglePlay() {
      const play = () => {
        if (this.frameIdx < this.totalCount - 1) {
          this.frameIdx++
          this.playId = window.requestAnimationFrame(play)
        } else {
          this.frameIdx = 0
          this.playId = null
        }
      }

      if (this.playId === null) {
        // go play
        this.playId = window.requestAnimationFrame(play)
      } else {
        // go stop
        window.cancelAnimationFrame(this.playId)
        this.playId = null
      }
    },
    onClick(data) {
      // this.$store.commit('findSelectedLabel', data)
    },
    onMove(data) {
      // console.log('move', data)
    },
    onDraw(label) {
      this.modified = true
      this.addLabel(label)
    },
  },
  watch: {
    videoUrl(val) {
      this.canvasData = []
      this.configs = []
      this.processVideo(val)
    },
    yamlUrl(val) {
      this.processYaml(val)
    },
    value(val) {
      this.frameIdx = val
    },
    count(val) {
      if (val > 0 && val < 110) {
        this.$alert('该摄像头总帧数少于110帧，无法用于训练', '包不可用', {
          confirmButtonText: '确定',
        })
      }
    },
  },
  components: { Snapshot },
}
</script>

<style lang="scss" scoped>
.labeler {
  width: 100%;
  max-width: 1920px;
  position: relative;
  overflow: hidden;
  &-play {
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    bottom: 0;
    background: white;
    padding: 5px 10px 0;
  }
}
.snapshot {
  height: 100%;
  &-container {
    width: 100%;
    margin-bottom: 38px;
  }
  &-middle {
    width: 100%;
    height: 300%;
    position: relative;
    top: -100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &-slider {
    padding: 0 20px;
  }
}
</style>
